import { render, staticRenderFns } from "./FormDisplayText.vue?vue&type=template&id=4a6acbde&"
import script from "./FormDisplayText.vue?vue&type=script&lang=ts&"
export * from "./FormDisplayText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports